module.exports = __webpack_public_path__ + "static/media/arrows-to-right.5f1b32de.svg";